import { AppStore } from "@/store/AppStore";
import {
  SessionKind,
  SessionPreviousChats,
  SessionPreviousChatsIndexTuple,
} from "@/store/sessions/types";
import { Dexie } from "dexie";

export const searchPreviousChatSessions = async ({
  store,
}: {
  store: AppStore;
}): Promise<SessionPreviousChats[]> => {
  const sessions = (await store.sessions.localTable
    .where("[kind+last_user_action_at+title+model_id]")
    .between(["GENERIC", Dexie.minKey, Dexie.minKey], ["GENERIC", Dexie.maxKey, Dexie.maxKey])
    .and(item => item.model_data.status !== "INITIAL" && item.model_data.last_user_action_at !== "")
    .reverse()
    .keys()) as unknown as SessionPreviousChatsIndexTuple[];

  return sessions.map(session => ({
    kind: session[0] as SessionKind,
    title: session[2],
    lastUserActionAt: session[1],
    modelId: session[3],
  }));
};

export const searchMostRecentSessionWithUserActivity = async ({
  store,
}: {
  store: AppStore;
}): Promise<SessionPreviousChats[]> => {
  const sessions = (await store.sessions.localTable
    .where("[kind+last_user_action_at+title+model_id]")
    .between(["GENERIC", Dexie.minKey, Dexie.minKey], ["GENERIC", Dexie.maxKey, Dexie.maxKey])
    .and(item => item.model_data.last_user_action_at != "")
    .reverse()
    .keys()) as unknown as SessionPreviousChatsIndexTuple[];

  return sessions.map(session => ({
    kind: session[0] as SessionKind,
    title: session[2],
    lastUserActionAt: session[1],
    modelId: session[3],
  }));
};
